/**
 * Route guard on `ver` — story 0.4 AC-5, AC-9.
 *
 * Composes with story 0.3's `<RotaProtegida>` rather than replacing it: that one
 * answers *"is anyone signed in"*, this one *"may this person see this screen"*.
 * Two questions, two guards, so neither has to know about the other.
 *
 * 🔒 Still UX (BR-17). The route not rendering saves the user from a screen full of
 * 403s; the server is what actually refuses the data.
 *
 * ⚠️ A disabled module and a missing permission produce the **same** outcome, on
 * purpose (`PERSONAS.md`): a Cliente must not be able to tell "iOX does not sell
 * this to me" from "iOX does not sell this to anyone", because the first leaks
 * what other tenants buy.
 */
import { Navigate, Outlet } from 'react-router'

import { useFlag } from '@/flags/flags'
import { usePermission } from '@/permissions/usePermission'

export function RotaComPermissao({
  chave,
  flag,
  children,
}: {
  /** A tela/aba key from `app/navigation.ts`. */
  chave: string
  /** Optional feature flag guarding the same route (BR-11, AC-9). */
  flag?: string
  children?: React.ReactNode
}) {
  const { ver } = usePermission(chave)
  const ligada = useFlag(flag ?? '')

  if (!ver || !ligada) {
    // Redirect rather than render an explanation: unlike the tenant guard, where
    // the user typed a specific client and deserves to know it was wrong, a screen
    // they simply cannot have is better left invisible — saying "you lack
    // finops.oportunidades" tells them the screen exists.
    return <Navigate to="/" replace />
  }

  return <>{children ?? <Outlet />}</>
}
